/** @format */

const config = {
    admin: require('../admin.prod.json'),
};

export default config;
